import { Component, OnInit } from '@angular/core';
import { ProductService } from '@app/shared/services/product/product.service';
import { ColorModel } from '@app/shared/models/color';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { AddProductPopupCompData, CartProduct, ProductAdditionalInfoModel, WishList } from '@app/shared/models/product';
import { MatDialog } from '@angular/material/dialog';
import { CartService } from '@app/feature/end-user/services/cart/cart.service';
import { WishlistService } from '@app/feature/end-user/services/wishlist/wishlist.service';
import { MessageService } from '@app/shared/services/common/message.service';
import { CommonService } from '@app/shared/services/common/common.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { APIResponse } from '@app/shared/services/core/ICore.interface';
import { GetProductDetailsByProductIdInterface, IMasterProductSizeDetails, SizeProductDetails, StyleProductDetails } from '@app/shared/services/product/getProductDetailsByProductId.interface';
import { CustomizedProductSizeInterface, GetCustomizedProductDetailsByProductIdInterface, CustomizedProductStyleInterface, GetCustomizedProductDetailsByProductIdShopifyInterface } from '@app/shared/services/product/getCustomizedProductDetailsByProductId.interface';
import { IProductDetailEditTextData, ProductDetailEditTextComponent } from '@app/shared/components/product-detail-edit-text/product-detail-edit-text.component';
import { PopupService } from '@app/shared/services/popup/popup.service';
import { PublishProductComponent } from '@app/shared/components/publish-product/publish-product.component';
import { UploadProductImageDialogComponent } from '@app/feature/store-admin/components/upload-product-image-dialog/upload-product-image-dialog.component';
import { environment } from '@env/environment';
import { CustomProductImageInterface, UpdateDefaultProductImageInterface, UpdateShowCustomImageFlagInterface, ProductGetById } from '@app/shared/services/product/uploadProductImages.interface';
import { EncrDecrService } from '../../services/encr-decr-service.service';
import { CryptoKeyValue, Constants } from '../../constants';
import { WarehouseProductDetailsInterface, WarehouseProductSizeInterface, WarehouseProductStyleInterface } from '@app/shared/services/product/warehouseProduct.interface';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { StateService } from '@app/shared/services/state/state.service';
import { getRoutePrefix } from '@app/shared/utils/route-prefix.util';
import { DesignHuddleImageService } from '@app/shared/services/design-huddle/design-huddle-image.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DecorationTypeService } from '@app/shared/services/decoration-type.service';
import { ProductDecoration } from '@app/shared/models/decoration-type.model';
interface ISizeList<U> {
  styleId: number;
  uniqueStyleId: number;
  sizeList: U[];
}
interface ISelectedProduct {
  tagData: string;
  name: string;
  unitCost: number;
  retailPrice: number;
  finishingPrice: number;
  categoryId: string;
  longDescription: string;
  rawDescription: string;
  printingCost: number;
  discountPercent: number;
  productFinalCost: number;
  isWarehouseProduct: boolean;
  ExpectedShipDate: string;
  labelData: string
}

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css']
})
export class ProductDetailComponent implements OnInit {
  public scrollbarOptions = { axis: 'y', theme: 'minimal-dark' };
  getProductById: ProductGetById;
  subHandler: any;
  sizeid: any;
  imageSrc: any;
  imageList: CustomProductImageInterface[] = [];
  imageListAll: CustomProductImageInterface[] = [];
  //imageListCustom: CustomProductImageInterface[] = [];
  productId!: any;
  typeId!: number;
  DecorationType: string;
  designId!: any;
  colorList: ColorModel[] = [];  // FOR LISTING THE PRODUCT AVAILABLE COLORS
  warehouseColorList: WarehouseProductStyleInterface[] = [];
  sizeList: ISizeList<CustomizedProductSizeInterface>[] = []; // For sizes of particular style  
  // warehouseSizeList: WarehouseProductStyleInterface[] = [];
  priceList !: any[];
  windowURLIndex!: number;
  // Local storage fields
  storeUrl !: any;
  userRole: any;
  userId: any;
  storeid: any;
  isSuccessAddToCart = false;  // To show go to cart button in html TRUE/FALSE
  currentSizeName: any;
  currentWarehouseSizeList: WarehouseProductSizeInterface[];
  currentStyle!: string;
  currentStyleId: number;
  defaultStyleUniqueId: number;
  isLoggedIn = false;
  CanEndUserCustomize: any;
  IsEmbroideryType: boolean = false;
  loading: boolean = true;
  private sizeQtyCache: { [key: string]: any } = {};
  selectedProduct: ISelectedProduct
    = {
      name: '',
      unitCost: 0,
      retailPrice: 0,
      finishingPrice: 0,
      categoryId: '',
      longDescription: '',
      rawDescription: '',
      printingCost: 0,
      discountPercent: 0,
      productFinalCost: 0,
      isWarehouseProduct: false,
      ExpectedShipDate: null,
      labelData: null,
      tagData: null
    };

  cartProduct !: CartProduct;
  wishList !: WishList;
  noOfCustomizedSides !: any;

  rateValue!: number;
  defaultImageSelected: string;
  IsActive: boolean = true;
  IsAvailable: boolean = true;
  HasActiveColors: any;
  sampleOrderForStoreAdmin: any;
  discount: number;
  IsPublished: any;
  // shopifyProduct: boolean = false;
  IsShopifyProduct: boolean = false;
  inksoftImageBaseUrl = environment.masterProductImgBaseURL;
  productAdditionalInfo: ProductAdditionalInfoModel;
  sizingLabelExist: boolean;
  CustomizationType: string;
  EmbroideryCost: any;
  EmbroiderySetUpCost: any;
  sizingLabelGenerated: boolean;
  productLabels: any[] = [{ text: '', backgroundColor: '', textColor: '' }]
  productTags: any[] = [{ tagtext: '' }]
  isSuperAdmin: string = 'false';
  isDecorationTypeChanged: boolean = false;
  // ------------------------------------
  // Decoration selector (WI-1378)
  /** Decoration label chosen for this specific published/customized product (from DecorationName on the detail response). */
  selectedDecorationName: string = null;
  decorations: ProductDecoration[] = [];
  selectedDecoration: ProductDecoration = null;
  /** Rate delta relative to the default decoration (for price adjustment on selection). */
  private defaultDecorationRate: number = 0;
  /** Product.ProductId (EF PK) captured from the API response for decoration lookup. */
  private masterProductId: number = null;

  get showDecorationSelector(): boolean {
    return this.userRole === 'EndUser' && this.decorations.length > 1;
  }

  constructor(private router: Router, private route: ActivatedRoute, private productService: ProductService,
    private notificationService: NotificationService, private loader: LoaderService,
    private popupService: PopupService,
    private cartService: CartService, private wishlistService: WishlistService, private messageService: MessageService,
    private commonService: CommonService, private errorhandlerService: ErrorhandlerService, public dialog: MatDialog,
    private EncrDecr: EncrDecrService, private stateService: StateService,
    private designHuddleImageService: DesignHuddleImageService,
    private sanitizer: DomSanitizer,
    private decorationTypeService: DecorationTypeService) {
  }

  ngOnInit() {
    this.rateValue = 5;

    this.userId = localStorage.getItem('userId');
    this.userRole = localStorage.getItem('role');
    this.isLoggedIn = this.userRole === 'EndUser';
    this.storeUrl = localStorage.getItem('storeUrl');
    this.storeid = localStorage.getItem('storeId');
    this.sampleOrderForStoreAdmin = localStorage.getItem('sampleOrder');
    this.subHandler = this.route.queryParams.subscribe(params => {
      this.typeId = Number(params.type);
      if (this.typeId == 1) {
        this.productId = Number(this.EncrDecr.get(CryptoKeyValue.Key, params.pid));//params.pid;
        this.designId = Number(this.EncrDecr.get(CryptoKeyValue.Key, params.designId));//params.designId;
        this.IsShopifyProduct = params.IsShopifyProduct != null ? JSON.parse(params.IsShopifyProduct) : false;
        this.isSuperAdmin = params.IsSuperAdmin
      }
      else if (this.typeId == 2) {
        this.productId = params.pid;
      }
      this.imageList = [];
      this.colorList = [];
      this.warehouseColorList = [];
      // Reset decoration state on each product load
      this.selectedDecorationName = null;
      this.decorations = [];
      this.selectedDecoration = null;
      this.defaultDecorationRate = 0;
      this.masterProductId = null;

      /**Initializing Product cart item with productid, designid, styleid */
      this.cartProduct = {
        productid: this.typeId == 2 ? 0 : this.productId,
        customizedProductId: null,
        categoryid: '',
        quantity: 1,
        sizeId: '',
        sizeName: '',
        colorCode: '',
        colorName: '',
        styleid: '',
        designid: this.designId,
        storeid: this.storeid,
        userid: this.userId,
        unitprice: 0,
        retailPrice: 0,
        warehouseProductId: null,
        EmbroideryCost: 0,
      };

      /**Initializing Product wishlist item with productid, designid, styleid */
      this.wishList = {
        productid: this.typeId == 2 ? 0 : this.productId,
        customizedProductId: '',
        categoryid: '',
        quantity: 1,
        sizeId: '',
        sizeName: '',
        colorCode: '',
        colorName: '',
        styleid: '',
        designid: this.designId,
        storeid: this.storeid,
        userid: this.userId,
        unitprice: 0,
        WarehouseProductId: 0
      };
      this.productAdditionalInfo = {
        Composition: null,
        MadeIn: "",
        ProductType: "",
        RN: "",
        Enable_Sizing_Label: false,
        Enable_Embroidery: false,
        ExpectedShipDate: '',
        DecorationType: ''
      }
      this.getProduct();
    });

    this.messageService.getMessage().subscribe(message => {
      this.CanEndUserCustomize = message.message['canEndUserCustomize'];
      this.userRole = message.message['userRole'];
    });
    this.CanEndUserCustomize = localStorage.getItem('canEndUserCustomize');

  }

  getProduct() {
    /** type 0 means raw product detail */
    /** type 1 means customized product detail */
    /** type 2 means warehouse product detail */
    if (this.typeId === 0) {
      this.getProductDetails(this.productId);
    }
    else if (this.typeId === 2) {
      this.fn_UpdateDesignViewedCount();
      this.getWarehouseProductDetails(this.productId);
    } else {
      this.fn_UpdateDesignViewedCount();
      if (this.IsShopifyProduct) {
        this.getCustomizedProductDetailsShopify(this.productId, this.designId);
      } else {
        this.getCustomizedProductDetails(this.productId, this.designId);
      }

    }
  }

  /** Function to display product color(s) in color selector */
  displayColor(obj: any) {
    return {
      'background': obj
    };
  }

  /** On clicking the product image thumbnail in carousel */
  selectProductImage(image: string) {
    this.imageSrc = image;
  }

  /** On selecting the product color from color selector warehouse product */
  selectWarehouseStyle(styleId: string) {
    this.cartProduct.quantity = this.wishList.quantity = 1;
    styleId = styleId.toString();
    this.cartProduct.styleid = styleId;
    this.wishList.styleid = styleId;
    // On selecting any style clearing the previous style size list
    this.currentSizeName = [];

    let currentSize = this.cartProduct;
    // On selecting any style updating the size list
    this.currentWarehouseSizeList = this.warehouseColorList.find(x => x.StyleId.toString() === styleId).Size;

    // set previously selected Size
    let size = this.currentWarehouseSizeList.find(x => x.SizeName == currentSize.sizeName);
    if (size != undefined && size.IsAvailable) {
      this.fn_SelectWarehouseSize(size.SizeId);
    } else {
      this.cartProduct.sizeId = null;
      this.cartProduct.sizeName = null;
      this.wishList.sizeId = null;
      this.wishList.sizeName = null;
    }

    // Finding the product FRONT/BACK/SIDE images for current styleid
    const j: WarehouseProductStyleInterface = this.warehouseColorList.find(x => x.StyleId.toString() === styleId);

    // Adding ColorCode, ColorName to cart item modal
    this.cartProduct.colorCode = j.HexCode;
    this.cartProduct.colorName = j.ColorName;
    // Adding ColorCode, ColorName to wishlist item modal
    this.wishList.colorCode = j.HexCode;
    this.wishList.colorName = j.ColorName;
    // -------------------------------------------------------------------------------

    this.imageList = [];
    this.imageList = this.mapImageForWarehouseProductByStyle(this.imageListAll, styleId);
    this.imageSrc = this.imageList[0].Image;
    this.currentStyle = styleId;
    this.currentStyleId = this.imageList[0].StyleId;
  }

  /** On selecting the product color from color selector */
  selectStyle(uniqueStyleId: string) {
    // if (this.IsShopifyProduct) {
    //   return false;
    // }
    this.sizeid = uniqueStyleId;
    this.cartProduct.styleid = uniqueStyleId;
    this.wishList.styleid = uniqueStyleId;
    // On selecting any style clearing the previous style size list
    this.currentSizeName = [];

    let currentSize = this.cartProduct;
    // On selecting any style updating the size list
    this.currentSizeName = this.sizeList.find(x => x.uniqueStyleId.toString() === uniqueStyleId).sizeList;
    // Updating the selected style sizes price list
    this.priceList = this.currentSizeName;

    // set previously selected Size
    let size = this.currentSizeName.find(x => x.Name == currentSize.sizeName);
    if (size != undefined) {
      this.fn_SelectSize(size.SizeId);
    }

    // Finding the product FRONT/BACK/SIDE images for current styleid
    const j: any[] = [this.colorList.find(x => x.uniqueStyleId.toString() === uniqueStyleId)];
    /** If raw product details */
    if (this.typeId === 0) {
      /** If raw product details */
      this.imageList = [];
      if (j) {
        j.forEach((k: any) => {
          // Stored values are absolute Azure Blob URLs post-migration; no host prefix needed.
          let imagePath = '';
          if (k.ImageFilePath_Front != null) {
            imagePath = k.ImageFilePath_Front;
          }
          if (k.ImageFilePath_Back != null) {
            imagePath = k.ImageFilePath_Back;
          }
          if (k.ImageFilePath_SleeveLeft != null) {
            imagePath = k.ImageFilePath_SleeveLeft;
          }
          if (k.ImageFilePath_SleeveRight != null) {
            imagePath = k.ImageFilePath_SleeveRight;
          }
          this.imageList.push({
            Id: 0,
            Image: imagePath,
            IsActive: true,
            IsDefault: true,
            IsCustom: false,
            IsAdded: false,
            IsEdited: false,
            StyleId: 0,
            UniqueStyleId: 0
          });
        });
      }
    } /** If customized product details*/ else {
      // Adding ColorCode, ColorName to cart item modal
      this.cartProduct.colorCode = j[0].colorCode;
      this.cartProduct.colorName = j[0].colorName;
      // Adding ColorCode, ColorName to wishlist item modal
      this.wishList.colorCode = j[0].colorCode;
      this.wishList.colorName = j[0].colorName;
      // -------------------------------------------------------------------------------
    }
    this.imageList = [];
    this.imageList = this.mapImageForCustomizeProductByStyle(this.imageListAll, uniqueStyleId);
    let defaultImage = this.imageList.find(x => x.IsDefault == true && x.Id >= 0);
    if (defaultImage)
      this.imageSrc = defaultImage.Image
    else if (this.imageList.length > 0)
      this.imageSrc = this.imageList[0].Image;

    // Add sizing label (Id == -99) if not already in list
    let sizingLabel = this.imageListAll.find(x => x.Id === -99 && x.UniqueStyleId == Number(uniqueStyleId));
    if (sizingLabel && !this.imageList.find(x => x.Id === -99))
      this.imageList.push(sizingLabel);

    this.currentStyle = uniqueStyleId;
    this.currentStyleId = this.imageList[0]?.StyleId;
    this.fn_GetSizeQty(this.productId, uniqueStyleId);
  }

  selectStyleShopify(uniqueStyleId: string) {
    this.cartProduct.styleid = uniqueStyleId;
    // On selecting any style updating the size list
    this.currentSizeName = this.sizeList.find(x => x.uniqueStyleId.toString() === uniqueStyleId).sizeList;
    // Updating the selected style sizes price list
    this.priceList = this.currentSizeName;

    let currentSize = this.cartProduct;
    // set previously selected Size
    let size = this.currentSizeName.find(x => x.Name == currentSize.sizeName);
    if (size != undefined) {
      this.fn_SelectSizeShopify(size.SizeId);
    } else {
      this.fn_SelectSizeShopify(this.priceList[0].SizeId);
    }

    let style = this.colorList.find(x => x.uniqueStyleId.toString() == uniqueStyleId);
    this.imageList = [];
    this.imageList = this.mapImageForCustomizeProductByStyle(this.imageListAll, uniqueStyleId);
    let defaultImage = this.imageList.find(x => x.IsDefault == true && x.Id >= 0);
    if (defaultImage)
      this.imageSrc = defaultImage.Image
    else if (this.imageList.length > 0)
      this.imageSrc = this.imageList[0].Image;

    // Add sizing label (Id == -99) if not already in list
    let sizingLabel = this.imageListAll.find(x => x.Id === -99 && x.UniqueStyleId == Number(uniqueStyleId));
    if (sizingLabel && !this.imageList.find(x => x.Id === -99))
      this.imageList.push(sizingLabel);

    // Adding ColorCode, ColorName to cart item modal
    this.cartProduct.colorCode = style.colorCode;
    this.cartProduct.colorName = style.colorName;

    this.currentStyle = uniqueStyleId;
    this.fn_GetSizeQty(this.productId, uniqueStyleId);
  }

  mapColor(res: StyleProductDetails[]): ColorModel[] {
    return res.map<ColorModel>((x: StyleProductDetails) => {
      return {
        colorCode: '#' + x.HtmlColor1,
        colorName: x.Name,
        ImageFilePath_Front: x.ImageFilePath_Front,
        ImageFilePath_Back: x.ImageFilePath_Back,
        ImageFilePath_SleeveLeft: x.ImageFilePath_SleeveLeft,
        ImageFilePath_SleeveRight: x.ImageFilePath_SleeveRight,
        styleId: x.ID.toString(),
        PngRelativeUrlWithProduct: '',
        IsActive: x.IsActiveColor,
        uniqueStyleId: 0,
        IsDefault: false,
      };

    });
  }
  mapColorForCustomizeProduct(res: GetCustomizedProductDetailsByProductIdInterface[], currentStyles: any): ColorModel[] {
    const savedStyles = res[0].SavedStyles;
    return savedStyles.map<ColorModel>((x: CustomizedProductStyleInterface) => {
      // Find matching style in latest current styles list on the basis of UniqueStyleId
      const currentStyle = currentStyles.find(s => s.UniqueStyleId === x.UniqueStyleId);

      return {
        colorCode: '#' + x.ColorCode,
        colorName: x.StyleName,
        IsActive: currentStyle ? currentStyle.IsActive : false, // fallback to false if not found
        ImageFilePath_Front: x.ImageFilePath_Front,
        ImageFilePath_Back: x.ImageFilePath_Back,
        ImageFilePath_SleeveLeft: x.ImageFilePath_SleeveLeft,
        ImageFilePath_SleeveRight: x.ImageFilePath_SleeveRight,
        styleId: x.StyleId.toString(),
        PngRelativeUrlWithProduct: '',
        uniqueStyleId: x.UniqueStyleId,
        IsDefault: false
      };
    });
  }


  mapSize(res: StyleProductDetails[]): ISizeList<SizeProductDetails>[] {
    return res.map<ISizeList<SizeProductDetails>>((x: StyleProductDetails) => {
      return {
        sizeList: x.Sizes,
        styleId: x.ID,
        uniqueStyleId: 0
      };
    });
  }

  mapSizeForCustomizeProduct(res: GetCustomizedProductDetailsByProductIdInterface[]): ISizeList<CustomizedProductSizeInterface>[] {
    return res[0].SavedStyles.map<ISizeList<CustomizedProductSizeInterface>>((x: CustomizedProductStyleInterface) => {
      // Defensive: fall back to matching by StyleId, then to an empty size list, so a single
      // unmatched SavedStyle (null UniqueStyleId) never hard-crashes the product-detail page.
      const matchedStyle = res[0].Styles.find(s => s.UniqueStyleId == x.UniqueStyleId)
        || res[0].Styles.find(s => (s as any).StyleId == x.StyleId);
      return {
        sizeList: matchedStyle ? matchedStyle.Sizes : [],
        styleId: x.StyleId,
        uniqueStyleId: x.UniqueStyleId
      };
    });
  }
  mapSizeForWarehouseProduct(res: WarehouseProductDetailsInterface): WarehouseProductStyleInterface[] {
    return res.WarehouseVariants.map<WarehouseProductStyleInterface>((style: WarehouseProductStyleInterface) => {
      const styleSize = res.WarehouseVariants.find(s => s.StyleId == style.StyleId).Size
        .map<WarehouseProductSizeInterface>((x: WarehouseProductSizeInterface) => {
          return {
            SizeId: x.SizeId,
            SizeName: x.SizeName,
            Price: x.Price,
            SortOrder: x.SortOrder,
            StockOnHandQuantity: x.StockOnHandQuantity,
            IsAvailable: x.StockOnHandQuantity > 0 ? true : false
          };
        });
      let isAvailable = styleSize.some((size) => {
        return size.IsAvailable;
      });
      return {
        StyleId: style.StyleId,
        ColorName: style.ColorName,
        HexCode: style.HexCode,
        IsActive: style.IsActive,
        Size: styleSize,
        IsDefault: false,
        IsAvailable: isAvailable
      };
    });
  }

  mapSizeForCustomizeProductShopify(res: GetCustomizedProductDetailsByProductIdShopifyInterface[]): ISizeList<CustomizedProductSizeInterface>[] {
    return res[0].SavedStyles.map<ISizeList<CustomizedProductSizeInterface>>((x: CustomizedProductStyleInterface) => {
      // Defensive: a SavedStyle may carry a null/unmatched UniqueStyleId (e.g. when the mapped
      // style row is inactive). Fall back to matching by StyleId, then to an empty size list,
      // so the whole product-detail page never hard-crashes on a single unmatched style.
      const matchedStyle = res[0].StyleList.find(s => s.UniqueStyleId == x.UniqueStyleId)
        || res[0].StyleList.find(s => s.StyleId == x.StyleId);
      return {
        sizeList: matchedStyle ? matchedStyle.Size : [],
        styleId: x.StyleId,
        uniqueStyleId: x.UniqueStyleId
      };
    });
  }

  mapImage(res: StyleProductDetails[]): CustomProductImageInterface[] {
    const imagesList = res.reduce((arr: CustomProductImageInterface[], x: StyleProductDetails) => {
      const backUrlImage = environment.imgBaseURL; // empty post Design Huddle migration; columns hold absolute blob URLs
      let imagePath = '';
      if (x.ImageFilePath_Back) {
        imagePath = backUrlImage + x.ImageFilePath_Back;
      }
      if (x.ImageFilePath_Front) {
        imagePath = backUrlImage + x.ImageFilePath_Front;
      }
      if (x.ImageFilePath_SleeveLeft) {
        imagePath = backUrlImage + x.ImageFilePath_SleeveLeft;
      }
      if (x.ImageFilePath_SleeveRight) {
        imagePath = backUrlImage + x.ImageFilePath_SleeveRight;
      }
      arr.push({
        Id: 0,
        Image: imagePath,
        IsActive: true,
        IsDefault: true,
        IsCustom: false,
        IsAdded: false,
        IsEdited: false,
        StyleId: 0,
        UniqueStyleId: 0
      });
      return arr;
    }, []);
    return imagesList.slice(0, 2);
  }

  mapImageForCustomizeProduct(res: any[]): CustomProductImageInterface[] {
    return res.reduce((arr: CustomProductImageInterface[], x: any) => {
      const inksoftImageBaseUrl = this.inksoftImageBaseUrl;
      const apiBaseUrl = environment.productCustomImageFolder;
      let imagePath = '';
      if (x.IsCustom)
        imagePath = apiBaseUrl + x.ImagePath;
      else if (x.Id == -1 || x.Id == -2 || (x.ImagePath && (x.ImagePath.startsWith('http://') || x.ImagePath.startsWith('https://'))))
        imagePath = x.ImagePath;  // Already full URL (Design Huddle / Azure Blob)
      else
        imagePath = inksoftImageBaseUrl + x.ImagePath;  // Inksoft relative path
      arr.push({
        Id: x.Id,
        Image: imagePath,
        IsActive: x.IsActive,
        IsDefault: x.IsDefault,
        IsCustom: x.IsCustom,
        IsAdded: false,
        IsEdited: false,
        StyleId: x.StyleId,
        UniqueStyleId: x.UniqueStyleId
      });
      return arr;
    }, []);
  }
  mapImageForWarehouseProduct(res: any): CustomProductImageInterface[] {
    return res.WarehouseVariants.reduce((arr: CustomProductImageInterface[], x: any) => {
      var data = x.WarehouseProductImages.reduce((arr2: CustomProductImageInterface[], x2: any) => {
        const apiBaseUrl = environment.warehouseProductCustomImageFolder;
        let imagePath = "";
        if (x2.ImageName.indexOf('https://stores.inksoft.com') !== -1)
          imagePath = x2.ImageName
        else
          imagePath = apiBaseUrl + x2.ImageName
        arr.push({
          Id: x2.ImageId,
          Image: imagePath,
          IsActive: true,
          IsDefault: false,
          IsCustom: false,
          IsAdded: false,
          IsEdited: false,
          StyleId: x2.StyleId,
          UniqueStyleId: 0
        });
        return arr2;
      }, []);
      return arr.concat(data);
    }, []);
  }
  mapImageForCustomizeProductShopify(res: any[]): CustomProductImageInterface[] {
    const imagesList = res.reduce((arr: CustomProductImageInterface[], x: any) => {
      const inksoftImageBaseUrl = this.inksoftImageBaseUrl;
      const apiBaseUrl = environment.productCustomImageFolder;
      let imagePath = '';
      if (x.IsCustom)
        imagePath = apiBaseUrl + x.ImagePath;
      else if (x.Id == -1 || x.Id == -2 || (x.ImagePath && (x.ImagePath.startsWith('http://') || x.ImagePath.startsWith('https://'))))
        imagePath = x.ImagePath;  // Already full URL (Design Huddle / Azure Blob)
      else
        imagePath = inksoftImageBaseUrl + x.ImagePath;  // Inksoft relative path
      arr.push({
        Id: x.Id,
        Image: imagePath,
        IsActive: x.IsActive,
        IsDefault: x.IsDefault,
        IsCustom: x.IsCustom,
        IsAdded: false,
        IsEdited: false,
        StyleId: x.StyleId,
        UniqueStyleId: x.UniqueStyleId
      });
      return arr;
    }, []);
    return imagesList;
  }

  mapImageForCustomizeProductByStyle(res: CustomProductImageInterface[], uniqueStyleId: any): CustomProductImageInterface[] {
    const seen = new Set<string>();
    let filtered = res.filter(x => {
      if (x.UniqueStyleId != uniqueStyleId) return false;
      if (seen.has(x.Image)) return false;
      seen.add(x.Image);
      return true;
    });

    // If DH/Azure mockup images exist (Id >= 0, non-Inksoft URL), prefer those
    // over plain Inksoft product images (which don't have the design overlay)
    const inksoftBase = this.inksoftImageBaseUrl; // https://stores.inksoft.com
    const dhMockups = filtered.filter(x => x.Id >= 0 && x.Image && !x.Image.startsWith(inksoftBase));
    if (dhMockups.length > 0) {
      // Keep only DH mockups and sizing labels (Id == -99), remove plain Inksoft & DH meta images (-1, -2)
      filtered = filtered.filter(x => x.Id === -99 || (x.Id >= 0 && !x.Image.startsWith(inksoftBase)));
    }

    return filtered;
  }
  mapImageForWarehouseProductByStyle(res: CustomProductImageInterface[], StyleId: any): CustomProductImageInterface[] {
    let images = res.filter(x => x.StyleId == StyleId);
    return images;
  }

  mapSelectedProduct(res: APIResponse<GetProductDetailsByProductIdInterface>): ISelectedProduct {
    var finalCost = 0;

    if (this.userRole === 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {
      if (this.sampleOrderForStoreAdmin == 0) {
        //Normal screen, i.e end user and detail page for store admin
        finalCost = this.currentSizeName[0].UnitPrice + res.Data.ResponseData.FinishingPrice + (res.Data.ResponseData.PrintingCost * (this.noOfCustomizedSides - 1)) + 0;
      } else {
        //final = unitCost + (printingCost * (NoOfSide - 1));
        finalCost = this.currentSizeName[0].UnitPrice + res.Data.ResponseData.FinishingPrice + (res.Data.ResponseData.PrintingCost * (this.noOfCustomizedSides - 1));

        //Apply discount if has any
        if (res.Data.ResponseData.Discount > 0 || res.Data.ResponseData.Discount != null)
          finalCost = finalCost - (finalCost * (res.Data.ResponseData.Discount / 100));
      }
    }
    else if (this.userRole === 'EndUser' || this.userRole === null || this.userRole === undefined) {
      //final = unitCost + (printingCost * (NoOfSide - 1)) + profitAdded;
      finalCost = this.currentSizeName[0].UnitPrice + (res.Data.ResponseData.PrintingCost * (this.noOfCustomizedSides - 1)) + 0;
    }



    return {
      name: res.Data.ResponseData.Name,
      unitCost: this.currentSizeName[0].UnitPrice,
      retailPrice: 0,
      finishingPrice: 0,
      categoryId: '',
      longDescription: this.sanitizeHtml(res.Data.ResponseData.LongDescription) as string,
      rawDescription: res.Data.ResponseData.LongDescription,
      printingCost: 0,
      discountPercent: res.Data.ResponseData.Discount,
      productFinalCost: finalCost,
      isWarehouseProduct: false,
      ExpectedShipDate: res.Data.ResponseData[0].ProductAdditionalInfo.ExpectedShipDate,
      labelData: res.Data.ResponseData[0].ProductMetadata,
      tagData: res.Data.ResponseData[0].Tags
    };
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  mapSelectedProductForCustomizeProduct(res: GetCustomizedProductDetailsByProductIdInterface): ISelectedProduct {
    var finalCost = 0;
    var profit = 0;
    if (this.userRole === 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {
      if (this.IsEmbroideryType) {
        if (this.sampleOrderForStoreAdmin == 0) {
          //Normal screen, i.e end user and detail page for store admin
          finalCost = this.commonService.fn_CalculateTotalCost(this.currentSizeName[0].UnitPrice, res.FinishingPrice, this.EmbroideryCost, this.noOfCustomizedSides, res.RetailPrice, this.IsEmbroideryType);
        } else {
          //Sample order page retial price
          finalCost = this.commonService.fn_CalculateTotalCost(this.currentSizeName[0].UnitPrice, res.FinishingPrice, this.EmbroideryCost, this.noOfCustomizedSides, 0, this.IsEmbroideryType);
          //Apply discount if has any
          if (res.Discount > 0 || res.Discount != null) {
            finalCost = finalCost - (finalCost * (res.Discount / 100));
          }

        }
      } else {

        if (this.sampleOrderForStoreAdmin == 0) {
          profit = res.RetailPrice;
          //Normal screen, i.e end user and detail page for store admin
          finalCost = this.commonService.fn_CalculateTotalCost(this.currentSizeName[0].UnitPrice, res.FinishingPrice, res.PrintingCost, this.noOfCustomizedSides, profit);
        } else {
          //Sample order page retial price
          if (this.IsEmbroideryType) {
            finalCost = this.commonService.fn_CalculateTotalCost(this.currentSizeName[0].UnitPrice, res.FinishingPrice, this.EmbroideryCost, this.noOfCustomizedSides, 0, this.IsEmbroideryType);
          } else {
            finalCost = this.commonService.fn_CalculateTotalCost(this.currentSizeName[0].UnitPrice, res.FinishingPrice, res.PrintingCost, this.noOfCustomizedSides, 0, this.IsEmbroideryType);
          }

          //Apply discount if has any
          if (res.Discount > 0 || res.Discount != null)
            finalCost = this.commonService.fn_calculateDiscount(finalCost, res.Discount);
        }
      }
    }
    else if (this.userRole === 'EndUser' || this.userRole === null || this.userRole === undefined) {
      profit = res.RetailPrice;
      if (this.IsEmbroideryType) {
        finalCost = this.commonService.fn_CalculateTotalCost(this.currentSizeName[0].UnitPrice, res.FinishingPrice, this.EmbroideryCost, this.noOfCustomizedSides, res.RetailPrice, this.IsEmbroideryType);
      } else {

        finalCost = this.commonService.fn_CalculateTotalCost(this.currentSizeName[0].UnitPrice, res.FinishingPrice, res.PrintingCost, this.noOfCustomizedSides, profit);
      }
    }

    return {
      name: res.Name,
      unitCost: res.ProductDescription[0].UnitCost,
      retailPrice: res.RetailPrice,
      finishingPrice: res.FinishingPrice,
      categoryId: res.ProductDescription[0].CategoryId,
      longDescription: this.sanitizeHtml(res.Description) as string,
      rawDescription: res.Description,
      printingCost: res.PrintingCost,
      discountPercent: res.Discount,
      productFinalCost: finalCost,
      isWarehouseProduct: false,
      ExpectedShipDate: null,
      labelData: res.ProductMetadata,
      tagData: res.Tags
    };
  }
  mapSelectedProductForWarehouseProduct(res: WarehouseProductDetailsInterface): ISelectedProduct {
    return {
      name: res.Title,
      unitCost: this.currentWarehouseSizeList[0].Price,
      retailPrice: 0,
      categoryId: '',
      longDescription: this.sanitizeHtml(res.Description) as string,
      rawDescription: res.Description,
      printingCost: 0,
      discountPercent: 0,
      productFinalCost: this.currentWarehouseSizeList[0].Price,
      isWarehouseProduct: true,
      finishingPrice: 0,
      ExpectedShipDate: null,
      labelData: null,
      tagData: null
    };
  }


  mapSelectedProductForCustomizeProductShopify(res: GetCustomizedProductDetailsByProductIdShopifyInterface): ISelectedProduct {
    var finalCost = 0;
    if (this.userRole === 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {
      // if (this.sampleOrderForStoreAdmin == 0) {
      //Normal screen, i.e end user and detail page for store admin
      if (this.IsEmbroideryType) {
        finalCost = this.commonService.fn_CalculateTotalCost(this.currentSizeName[0].UnitPrice, res.FinshingPrice, this.EmbroideryCost, this.noOfCustomizedSides, res.ShopifyProfit, this.IsEmbroideryType);
      } else {
        finalCost = this.commonService.fn_CalculateTotalCost(this.currentSizeName[0].UnitPrice, res.FinshingPrice, res.PrintingCost, this.noOfCustomizedSides, res.ShopifyProfit);
      }

    }
    return {
      name: res.Name,
      unitCost: res.ProductDescription.UnitCost,
      retailPrice: res.ShopifyProfit,
      categoryId: res.ProductDescription.CategoryId,
      longDescription: this.sanitizeHtml(res.Description) as string,
      rawDescription: res.Description,
      printingCost: res.PrintingCost,
      discountPercent: res.Discount,
      productFinalCost: finalCost,
      isWarehouseProduct: false,
      finishingPrice: res.FinshingPrice,
      ExpectedShipDate: null,
      labelData: res.ProductMetadata,
      tagData: res.Tags
    };
  }
  /** Gets raw product details */
  getProductDetails(productId: string) {
    this.loader.show();
    this.productService
      .getProductDetailsByProductId(productId)
      .subscribe((res: any) => {
        if (res.StatusCode === 200) {
          this.priceList = res.Data.ResponseData.Styles[0].Sizes; // all sizes of single style
          this.currentSizeName = this.priceList; // all sizes of single style for displaying a deafult sizes of any single style
          this.noOfCustomizedSides = res.Data.ResponseData.length;
          this.colorList = this.mapColor(res.Data.ResponseData.Styles);
          // Iterating on styles of a single product
          // this.sizeList = this.mapSize(res.Data.ResponseData.Styles);
          this.imageList = this.mapImage(res.Data.ResponseData.Styles);
          // For showing the unique product description, product name
          // For default price of any single style         
          this.selectedProduct = this.mapSelectedProduct(res);
          // Default image of any style, any side of product to display in product image preview
          this.imageSrc = this.imageList[0];
          this.loader.hide();
        } else {
          this.loader.hide();
          this.notificationService.error('Something went wrong', 'error');
        }
      }, (err: any) => {
        this.loader.hide();
        // this.notificationService.error('Something went wrong', 'error');
        this.errorhandlerService.handleError(err);
      });
  }

  /** Gets customized product details */
  getCustomizedProductDetails(productId: string, designId: string) {
    this.storeid = localStorage.getItem("storeId");
    this.loader.show();
    this.productService
      .getCustomizedProductDetailsByProductId(productId, designId, this.storeid)
      .subscribe((res: any) => {
        if (res.StatusCode === 200 && res.Data.ResponseData.length > 0) {
          this.noOfCustomizedSides = res.Data.ResponseData.length;
          this.storeid = res.Data.ResponseData[0].StoreId;
          // this.shopifyProduct = res.Data.ResponseData[0].IsShopifyProduct
          localStorage.setItem("storeId", res.Data.ResponseData[0].StoreId);
          this.IsPublished = res.Data.ResponseData[0].IsPublished;
          // Adding customizedProductId,categoryid to cart item modal
          this.cartProduct.customizedProductId = res.Data.ResponseData[0].CustomizedProductId;
          this.cartProduct.categoryid = res.Data.ResponseData[0].ProductDescription[0].CategoryId;
          this.cartProduct.retailPrice = res.Data.ResponseData[0].RetailPrice;
          // Adding customizedProductId,categoryid to wishlist item modal
          this.wishList.customizedProductId = res.Data.ResponseData[0].CustomizedProductId;
          this.wishList.categoryid = res.Data.ResponseData[0].ProductDescription[0].CategoryId;
          this.IsEmbroideryType = res.Data.ResponseData[0].IsEmbroideryType;
          this.CustomizationType = this.IsEmbroideryType ? Constants.EmbroideryType : Constants.ScreenPrint;
          this.DecorationType = res.Data.ResponseData[0].ProductAdditionalInfo.DecorationType,
            this.EmbroideryCost = res.Data.ResponseData[0].EmbroideryCost,
            this.EmbroiderySetUpCost = res.Data.ResponseData[0].EmbroiderySetUpCost,
            this.productAdditionalInfo = res.Data.ResponseData[0].ProductAdditionalInfo;
          this.selectedDecorationName = res.Data.ResponseData[0].DecorationName || null;
          this.sizingLabelExist = res.Data.ResponseData[0].SizingLabelExist;
          // Load per-product decorations using Product.ProductId (EF PK) from ProductAdditionalInfo.
          const masterPid = res.Data.ResponseData[0].ProductAdditionalInfo && res.Data.ResponseData[0].ProductAdditionalInfo.ProductId
            ? res.Data.ResponseData[0].ProductAdditionalInfo.ProductId
            : null;
          this.loadDecorations(masterPid);
          this.sizingLabelGenerated = res.Data.ResponseData[0].IsSizingLabelGenerated;
          // -------------------------------------------------------------------------------
          // all sizes of single style for displaying a default sizes of any single style
          this.priceList = res.Data.ResponseData[0].Sizes;
          this.currentSizeName = this.priceList; // for displaying a default sizes of any single style in HTML
          this.colorList = this.mapColorForCustomizeProduct(res.Data.ResponseData, res.Data.ResponseData[0].Styles);
          this.sizeList = this.mapSizeForCustomizeProduct(res.Data.ResponseData);
          // API now returns Design Huddle images in ResponseData1 - just map as before
          this.imageListAll = this.mapImageForCustomizeProduct(res.Data.ResponseData1);
          this.selectedProduct = this.mapSelectedProductForCustomizeProduct(res.Data.ResponseData[0]);
          this.selectedProduct.ExpectedShipDate = res.Data.ResponseData[0].ProductAdditionalInfo ? res.Data.ResponseData[0].ProductAdditionalInfo.ExpectedShipDate : null;
          this.IsActive = res.Data.ResponseData[0].ProductDescription[0].IsActive;
          //this.imageSrc = this.imageList[0];
          if (this.selectedProduct.labelData) {
            try {
              this.productLabels = JSON.parse(this.selectedProduct.labelData);
            } catch (e) {
              // Legacy format — not JSON, keep defaults
            }
          }
          if (this.selectedProduct.tagData) {
            try {
              this.productTags = JSON.parse(this.selectedProduct.tagData);
            } catch (e) {
              // Legacy comma-separated format
              this.productTags = this.selectedProduct.tagData.split(',').map(t => ({ tagtext: t.trim() }));
            }
          }
          // Check if decoration type has changed
          this.checkDecorationTypeChanged();
          // assign default style and default images
          let defaultImage = this.imageListAll.find(x => x.IsDefault == true);
          if (!defaultImage) {
            defaultImage = this.imageListAll[0];
          }
          this.imageList = this.mapImageForCustomizeProductByStyle(this.imageListAll, defaultImage.UniqueStyleId);
          // Use first filtered image as main (DH mockup preferred over -1 meta image)
          const firstFiltered = this.imageList.find(x => x.Id >= 0);
          this.imageSrc = firstFiltered ? firstFiltered.Image : defaultImage.Image;
          if (this.IsPublished == false) {
            // let Info = {
            //   designId: this.designId,
            //   productId: this.productId,
            //   IsPublished: this.IsPublished
            // }
            // this.dialog.open(AddProductPopupComponent, {
            //   data: { dataInksoft: Info }
            // });
            const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
              data: {
                message: "Continue product customization!",
                title: "Finish Customization",
                noButton: false
              }
            });

            dialogRef.afterClosed().subscribe(result => {
              const data: AddProductPopupCompData = {
                designId: this.designId,
                ProductId: this.productId,
                IsPublished: this.IsPublished,
                haveNoStyles: true,
                shopifyProduct: false,
                isEditCase: true,
                isProductReplaceCase: false,
                ProductAdditionalInfo: this.productAdditionalInfo,
                SizingLabelExist: this.sizingLabelExist,
                SizingLabelImage: this.imageList.find(x => x.Id < 0) ? this.imageList.find(x => x.Id < 0).Image : null,
                Sizes: this.sizeList[0].sizeList.map<IMasterProductSizeDetails>((s) => {
                  return {
                    Name: s.Name,
                    LongName: s.LongName,
                    ID: null,
                    SortOrder: null,
                    Weight: null,
                    UnitPrice: null,
                    AvailableQty: 0
                  };
                })
              };
              this.stateService.updateAddProductPopupdata(data);
              this.router.navigate(['/store/addproduct']);
            });
          }
          this.selectStyle(defaultImage.UniqueStyleId.toString()); // select the default style
          let defaultColor = this.colorList.find(x => x.uniqueStyleId == defaultImage.UniqueStyleId);
          if (defaultColor) {
            defaultColor.IsDefault = true; // select the default color
          }

          // Set lowest price
          this.selectedProduct.unitCost = this.fn_ShowLowestPrice();
          this.defaultStyleUniqueId = res.Data.ResponseData[0].StyleId;

          this.selectedProduct.productFinalCost = this.fn_getProductFinalCost(this.selectedProduct);

          var length = this.colorList.length;
          var colorActive = 0;
          for (let index = 0; index < length; index++) {
            //this.colorList.splice(1, 1);
            if (this.colorList[index].IsActive)
              colorActive = colorActive + 1;
          }

          //No color is active thus hide the options for publish, cart etc
          this.HasActiveColors = colorActive > 0 ? true : false;

          // For showing the unique product description, product name
          // For default price of any single style

          this.loader.hide();
        } else {
          this.loader.hide();
          this.notificationService.error('An error occured', 'error');
        }
      }, (err: any) => {
        this.loader.hide();
        this.notificationService.error('An error occured', 'error');
      });

  }

  /** Gets Warehouse product details */
  getWarehouseProductDetails(productId: string) {
    this.loader.show();
    this.productService
      .getCustomProductsDetails(productId)
      .subscribe((res: any) => {
        if (res.StatusCode === 200 && res.Data.ResponseData) {
          this.cartProduct.warehouseProductId = res.Data.ResponseData.ProductId;
          this.cartProduct.customizedProductId = res.Data.ResponseData.CustomizedProductId;
          this.cartProduct.designid = res.Data.ResponseData.DesignId;
          this.cartProduct.categoryid = res.Data.ResponseData.Categories[0].CategoryId;
          // Adding customizedProductId,categoryid to wishlist item modal
          this.wishList.WarehouseProductId = res.Data.ResponseData.ProductId;
          this.wishList.categoryid = res.Data.ResponseData.Categories[0].CategoryId;
          // -------------------------------------------------------------------------------

          // this.warehouseColorList = this.mapColorForWarehouseProduct(res.Data.ResponseData);
          this.warehouseColorList = this.mapSizeForWarehouseProduct(res.Data.ResponseData);
          //this.productAdditionalInfo = null;
          // all sizes of single style for displaying a default sizes of any single style
          let defaultColor = this.warehouseColorList.find(x => x.IsAvailable);
          if (!defaultColor) {
            defaultColor = this.warehouseColorList[0];
            this.IsAvailable = false;
          }
          this.currentWarehouseSizeList = defaultColor.Size;

          // Assign all styles Images
          this.imageListAll = this.mapImageForWarehouseProduct(res.Data.ResponseData);


          this.selectedProduct = this.mapSelectedProductForWarehouseProduct(res.Data.ResponseData);
          this.IsActive = res.Data.ResponseData.IsActive;
          //this.imageSrc = this.imageList[0];

          // assign default style and default images
          //let defaultImage = this.imageListAll.find(x => defaultColor.StyleId == x.StyleId);
          //this.imageSrc = defaultImage.Image;
          let defaultImage = this.imageListAll.find(x => x.IsDefault == true);
          if (!defaultImage) {
            defaultImage = this.imageListAll[0];
          }
          this.imageListAll = this.imageListAll.concat(res.Data.ResponseData1);
          this.imageList = this.mapImageForWarehouseProductByStyle(this.imageListAll, defaultImage.StyleId);

          this.selectWarehouseStyle(defaultImage.StyleId.toString()); // select the default style
          //defaultColor = this.warehouseColorList.find(x => x.StyleId.toString() == defaultImage.StyleId.toString());
          defaultColor.IsDefault = true; // select the default color

          // Set lowest price
          this.selectedProduct.unitCost = this.fn_ShowLowestPriceWarehouse(defaultColor.Size);
          //this.selectedProduct.productFinalCost = this.fn_ShowLowestPriceWarehouse(defaultColor.Size);

          var length = this.warehouseColorList.length;
          var colorActive = 0;
          for (let index = 0; index < length; index++) {
            if (this.warehouseColorList[index].IsActive)
              colorActive = colorActive + 1;
          }

          //No color is active thus hide the options for publish, cart etc
          this.HasActiveColors = colorActive > 0 ? true : false;

          // For showing the unique product description, product name
          // For default price of any single style

          this.loader.hide();
        } else {
          this.loader.hide();
          this.notificationService.error('An error occured', 'error');
        }
      }, (err: any) => {
        this.loader.hide();
        this.notificationService.error('An error occured', 'error');
      });
  }

  getCustomizedProductDetailsShopify(productId: string, designId: string) {
    //this.storeid = localStorage.getItem("storeId");
    this.getProductById = {
      productId: Number(this.productId),
      designId: this.designId,
      storeId: 0
    }
    this.loader.show();
    this.productService.getCustomizedProductDetailsWithStyle(this.getProductById).
      subscribe((res: any) => {
        if (res.StatusCode === 200 && res.Data.ResponseData.length > 0) {
          try {
          // API returns grouped data: [{ProductId, CustomizedProducts: [...], StyleList, ...}]
          // Flatten to the format expected by product-detail component
          let responseData = res.Data.ResponseData;
          const firstItem = responseData[0];
          if (firstItem.CustomizedProducts && Array.isArray(firstItem.CustomizedProducts)) {
            // Grouped response — flatten CustomizedProducts into top-level array
            const grouped = firstItem;
            responseData = (grouped.CustomizedProducts || []).map((cp: any) => ({
              ...cp,
              ProductId: grouped.ProductId,
              DesignId: grouped.DesignId,
              ProductDescription: grouped.ProductDescription,
              Description: grouped.Description,
              InkSoftUserId: grouped.InkSoftUserId,
              ApplicationUserId: grouped.ApplicationUserId,
              StyleList: grouped.StyleList,
              ImageFilePath_Front: grouped.ImageFilePath_Front,
              ImageFilePath_Back: grouped.ImageFilePath_Back,
              ImageFilePath_SleeveLeft: grouped.ImageFilePath_SleeveLeft,
              Supplier: grouped.Supplier,
              ProductAdditionalInfo: grouped.ProductAdditionalInfo,
              SizeGuides: grouped.SizeGuides,
              SizingLabelExist: grouped.SizingLabelExist,
              IsSizingLabelGenerated: grouped.IsSizingLabelGenerated,
              Discount: grouped.Discount
            }));
          }

          this.noOfCustomizedSides = responseData.length;

          this.cartProduct.customizedProductId = responseData[0].CustomizedProductId;
          this.cartProduct.categoryid = responseData[0].ProductDescription.CategoryId;
          this.cartProduct.retailPrice = responseData[0].RetailPrice;

          this.productAdditionalInfo = responseData[0].ProductAdditionalInfo;
          this.selectedDecorationName = responseData[0].DecorationName || null;
          this.sizingLabelExist = responseData[0].SizingLabelExist;
          this.IsEmbroideryType = responseData[0].IsEmbroideryType;
          this.CustomizationType = this.IsEmbroideryType ? Constants.EmbroideryType : Constants.ScreenPrint;
          this.DecorationType = responseData[0].ProductAdditionalInfo.DecorationType;
          this.EmbroideryCost = responseData[0].EmbroideryCost,
            this.sizingLabelGenerated = responseData[0].IsSizingLabelGenerated;
          // Load per-product decorations using Product.ProductId (EF PK) from ProductAdditionalInfo.
          const masterPidShopify = responseData[0].ProductAdditionalInfo && responseData[0].ProductAdditionalInfo.ProductId
            ? responseData[0].ProductAdditionalInfo.ProductId
            : null;
          this.loadDecorations(masterPidShopify);
          this.EmbroiderySetUpCost = responseData[0].EmbroiderySetUpCost,
            // -------------------------------------------------------------------------------
            // all sizes of single style for displaying a default sizes of any single style
            this.priceList = responseData[0].Sizes;
          this.currentSizeName = this.priceList; // for displaying a default sizes of any single style in HTML
          this.colorList = this.mapColorForCustomizeProduct(responseData, responseData[0].StyleList);
          this.colorList[0].IsDefault = true;
          this.sizeList = this.mapSizeForCustomizeProductShopify(responseData);
          // API now returns Design Huddle images in ResponseData1 - just map as before
          this.imageListAll = this.mapImageForCustomizeProductShopify(res.Data.ResponseData1);
          this.selectedProduct = this.mapSelectedProductForCustomizeProductShopify(responseData[0]);
          this.selectedProduct.ExpectedShipDate = responseData[0].ProductAdditionalInfo ? responseData[0].ProductAdditionalInfo.ExpectedShipDate : null;
          this.IsActive = responseData[0].ProductDescription.IsActive;

          if (responseData[0].ProductMetadata) {
            try {
              this.productLabels = JSON.parse(responseData[0].ProductMetadata);
            } catch (e) {
              // Legacy format — not JSON, keep defaults
            }
          }
          if (responseData[0].Tags) {
            try {
              this.productTags = JSON.parse(responseData[0].Tags);
            } catch (e) {
              // Legacy comma-separated format — convert to expected structure
              this.productTags = responseData[0].Tags.split(',').map(t => ({ tagtext: t.trim() }));
            }
          }
          // Check if decoration type has changed
          this.checkDecorationTypeChanged();
          // assign default style and default images
          let defaultImage = this.imageListAll.find(x => x.IsDefault == true);
          if (!defaultImage && this.imageListAll.length > 0) {
            defaultImage = this.imageListAll[0];
          }
          if (defaultImage) {
            this.imageList = this.mapImageForCustomizeProductByStyle(this.imageListAll, defaultImage.UniqueStyleId);
            // Use first filtered image as main (DH mockup preferred over -1 meta image)
            const firstFiltered = this.imageList.find(x => x.Id >= 0);
            this.imageSrc = firstFiltered ? firstFiltered.Image : defaultImage.Image;
          }

          if (this.colorList.length > 0) {
            this.selectStyleShopify(this.colorList[0].uniqueStyleId.toString()); // select the default style
          }
          let defaultColor = this.colorList.find(x => x.uniqueStyleId == (defaultImage ? defaultImage.UniqueStyleId : this.colorList[0]?.uniqueStyleId));
          if (defaultColor) {
            defaultColor.IsDefault = true; // select the default color
          }

          // Set lowest price
          // this.selectedProduct.unitCost = this.fn_ShowLowestPrice();
          this.defaultStyleUniqueId = responseData[0].StyleId;

          var length = this.colorList.length;
          var colorActive = 0;
          for (let index = 0; index < length; index++) {
            //this.colorList.splice(1, 1);
            if (this.colorList[index].IsActive)
              colorActive = colorActive + 1;
          }

          //No color is active thus hide the options for publish, cart etc
          this.HasActiveColors = colorActive > 0 ? true : false;

          } catch (processingError) {
            console.error('Error processing product details:', processingError);
            this.notificationService.error('Error loading product details', 'Error');
          }

          this.loader.hide();
        } else {
          this.loader.hide();
          this.notificationService.error('An error occured', 'error');
        }
      }, (err: any) => {
        this.loader.hide();
        this.notificationService.error('An error occured', 'error');
      });
  }

  //fn_CalculateDicount(unitCost: number, Discount: number): number {
  //  var discount = (unitCost * Discount) / 100;
  //  return discount.toFixed(2);
  //  }

  /** Gets lowest price from entire styles and size of product */
  fn_ShowLowestPrice() {
    const unitPriceList = this.sizeList.reduce((current, next) => {
      next.sizeList.forEach(size => {
        current.push({
          UnitPrice: size.UnitPrice
        })
      });
      return current;
    }, []);
    const lowestUnitPrice = unitPriceList.sort((a, b) => a.UnitPrice - b.UnitPrice);
    return lowestUnitPrice[0].UnitPrice;
  }
  /** For warehouse product Gets lowest price from entire styles and size of product */
  fn_ShowLowestPriceWarehouse(sizes: WarehouseProductSizeInterface[]) {
    const priceList = sizes.reduce((current, next) => {
      current.push({
        Price: next.Price
      });
      return current;
    }, []);
    const lowestPrice = priceList.sort((a, b) => a.Price - b.Price);
    return lowestPrice[0].Price;
  }

  /** Gets price based on product size */
  fn_SelectSize(sizeId: number) {
    const selectedSize = this.priceList.find(x => x.SizeId === sizeId);
    // Adding sizeId, sizeName, unitprice to cart modal
    // const z: any = this.sizeid;
    this.cartProduct.sizeId = selectedSize.SizeId;
    this.cartProduct.sizeName = selectedSize.Name;
    this.cartProduct.unitprice = selectedSize.UnitPrice;
    // Adding sizeId, sizeName, unitprice to cart modal
    this.wishList.sizeId = selectedSize.SizeId;
    this.wishList.sizeName = selectedSize.Name;
    this.wishList.unitprice = selectedSize.UnitPrice;
    // ----------------------------------------------------------------------------
    this.selectedProduct.unitCost = selectedSize.UnitPrice;
    this.selectedProduct.productFinalCost = this.fn_getProductFinalCost(this.selectedProduct);
  }

  /** Gets price based on Warehouse product size */
  fn_SelectWarehouseSize(sizeId: number) {
    this.cartProduct.quantity = this.wishList.quantity = 1;
    const selectedSize = this.currentWarehouseSizeList.find(x => x.SizeId === sizeId);
    // Adding sizeId, sizeName, price to cart modal
    this.cartProduct.sizeId = selectedSize.SizeId;
    this.cartProduct.sizeName = selectedSize.SizeName;
    this.cartProduct.unitprice = selectedSize.Price;
    // Adding sizeId, sizeName, price to wishlist modal
    this.wishList.sizeId = selectedSize.SizeId;
    this.wishList.sizeName = selectedSize.SizeName;
    this.wishList.unitprice = selectedSize.Price;
    // ----------------------------------------------------------------------------
    this.selectedProduct.unitCost = selectedSize.Price;
    this.selectedProduct.productFinalCost = selectedSize.Price;
  }
  fn_SelectSizeShopify(sizeId: number) {
    const selectedSize = this.priceList.find(x => x.SizeId === sizeId);
    // Adding sizeId, sizeName, unitprice to cart modal
    this.cartProduct.sizeId = selectedSize.SizeId;
    this.cartProduct.sizeName = selectedSize.Name;
    this.cartProduct.unitprice = selectedSize.UnitPrice;
    this.selectedProduct.unitCost = selectedSize.UnitPrice;
    this.selectedProduct.productFinalCost = this.fn_getProductFinalCostShopify(this.selectedProduct);
  }

  fn_getProductFinalCost(selectedProduct: any) {
    var unitPrice: number = Number(selectedProduct.unitCost);
    const selectedSize = this.priceList.find(x => x.SizeId === this.cartProduct.sizeId);
    if (selectedSize)
      unitPrice = selectedSize.UnitPrice;

    var finalCost = 0;

    if (this.userRole === 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {

      if (this.IsEmbroideryType) {
        if (this.sampleOrderForStoreAdmin == 0) {
          //Normal screen, i.e end user and detail page for store admin
          finalCost = this.commonService.fn_CalculateTotalCost(unitPrice, selectedProduct.finishingPrice, this.EmbroideryCost, this.noOfCustomizedSides, selectedProduct.retailPrice, this.IsEmbroideryType);
        } else {
          //Sample order page retial price
          finalCost = this.commonService.fn_CalculateTotalCost(unitPrice, selectedProduct.finishingPrice, this.EmbroideryCost, this.noOfCustomizedSides, 0, this.IsEmbroideryType);
          //Apply discount if has any
          if (selectedProduct.discountPercent > 0 || selectedProduct.discountPercent != null) {
            finalCost = this.commonService.fn_calculateDiscount(finalCost, selectedProduct.discountPercent);
          }

        }
      } else {
        if (this.sampleOrderForStoreAdmin == 0) {
          //Normal screen, i.e end user and detail page for store admin
          finalCost = unitPrice + selectedProduct.finishingPrice + (selectedProduct.printingCost * (this.noOfCustomizedSides - 1)) + selectedProduct.retailPrice;
        } else {
          //Sample order page retial price
          finalCost = unitPrice + selectedProduct.finishingPrice + (selectedProduct.printingCost * (this.noOfCustomizedSides - 1));
          //Apply discount if has any
          if (selectedProduct.discountPercent > 0 || selectedProduct.discountPercent != null) {
            finalCost = finalCost - (finalCost * (selectedProduct.discountPercent / 100));
            finalCost += this.EmbroideryCost + this.EmbroiderySetUpCost;
          }

        }

      }

    }
    else if (this.userRole === 'EndUser' || this.userRole === null || this.userRole === undefined) {
      if (this.IsEmbroideryType) {
        finalCost = unitPrice + selectedProduct.finishingPrice + ((this.EmbroideryCost) * (this.noOfCustomizedSides - 1)) + selectedProduct.retailPrice;
      } else {
        finalCost = unitPrice + selectedProduct.finishingPrice + (selectedProduct.printingCost * (this.noOfCustomizedSides - 1)) + selectedProduct.retailPrice;
      }

    }

    return finalCost;
  }
  fn_getProductFinalCostShopify(selectedProduct: any) {
    var finalCost = 0;
    if (this.IsEmbroideryType) {
      finalCost = this.commonService.fn_CalculateTotalCost(selectedProduct.unitCost, selectedProduct.finishingPrice, this.EmbroideryCost, this.noOfCustomizedSides, selectedProduct.retailPrice);
    } else {
      var profit = 0;
      profit =
        finalCost = this.commonService.fn_CalculateTotalCost(selectedProduct.unitCost, selectedProduct.finishingPrice, selectedProduct.printingCost, this.noOfCustomizedSides, selectedProduct.retailPrice);
    }
    //Apply discount if has any
    if (selectedProduct.discountPercent > 0 || selectedProduct.discountPercent != null)
      finalCost = this.commonService.fn_calculateDiscount(finalCost, selectedProduct.discountPercent);

    return finalCost;
  }

  /** Function to increment quantity */
  fn_IncrementQty() {
    if (this.currentWarehouseSizeList) {
      const selectedSize = this.currentWarehouseSizeList.find(x => x.SizeId === this.cartProduct.sizeId);
      let insertedQuantity = this.cartProduct.quantity + 1;
      if (selectedSize.StockOnHandQuantity < insertedQuantity) {
        var style = this.warehouseColorList.find((style) => {
          return style.Size.some((siz) => {
            return siz.SizeId === selectedSize.SizeId;
          });
        });
        this.notificationService.error('Only ' + this.cartProduct.quantity + ' quantity are available for Size- ' + selectedSize.SizeName + ' Color- ' + style.ColorName + ' right now.', 'Error');
        return false;
      }
    }
    if (!this.currentWarehouseSizeList && this.loading)
      return false
    if (!this.currentWarehouseSizeList && this.cartProduct.sizeName == '' || this.cartProduct.sizeName == null) {
      this.notificationService.info('Please select a size!', 'Info');
      return false;
    }
    var currentSize = this.currentSizeName.find(x => x.Name == this.cartProduct.sizeName)
    if (!this.currentWarehouseSizeList && currentSize && currentSize.AvailableQty == this.cartProduct.quantity)
      return false;

    ++this.cartProduct.quantity;
    ++this.wishList.quantity;
  }

  /** Function to decrement quantity */
  fn_DecrementQty() {
    if (this.cartProduct.quantity === 1) {
      return;
    } else {
      --this.cartProduct.quantity;
    }
    if (this.wishList.quantity === 1) {
      return;
    } else {
      --this.wishList.quantity;
    }
  }

  /** Function to add item to cart */
  getGuestId() {
    const guestId = localStorage.getItem('guestId');
    if (guestId) {
      return guestId;
    } else {
      const id = Math.ceil(Math.random() * 100000000);
      localStorage.setItem('guestId', id.toString());
      return id.toString();
    }
  }
  fn_AddToCart() {
    this.userId = localStorage.getItem('userId');
    this.userRole = localStorage.getItem('role');
    this.storeid = localStorage.getItem('storeId');
    if (this.storeid == "null")
      this.storeid = null;
    // if (this.storeid == undefined && this.sampleOrderForStoreAdmin == 1)
    //   this.storeid = this.userId;

    const guestId = this.getGuestId();
    const userId = this.userId ? this.userId : this.getGuestId();
    if (!this.cartProduct.sizeId) {
      this.notificationService.error('Please select size', 'Error');
      return;
    }
    if (!this.cartProduct.styleid) {
      this.notificationService.error('Please select color', 'Error');
      return;
    }
    this.loader.show();
    this.cartProduct.userid = userId;
    this.cartProduct.storeid = this.storeid;
    this.cartProduct.guestid = guestId;
    this.cartProduct.FinshingPrice = this.selectedProduct.finishingPrice != null ? this.selectedProduct.finishingPrice : 0;
    this.cartProduct.EmbroideryCost = this.EmbroideryCost;
    this.cartService.AddItemToCart(this.cartProduct).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.fn_GetCartItems();
        this.notificationService.success('Product added to cart', 'Success');
        this.isSuccessAddToCart = true;
        this.loader.hide();
      } else {
        this.isSuccessAddToCart = false;
        this.notificationService.error('An error occured', 'Error');
        this.loader.hide();
      }
    }, (err: any) => {
      this.isSuccessAddToCart = false;
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  /** Function to add item to WishList */
  fn_AddToWishList() {
    this.userId = localStorage.getItem('userId');
    this.userRole = localStorage.getItem('role');
    this.storeid = localStorage.getItem('storeId');

    if (this.userRole) {
      if (!this.wishList.sizeId) {
        this.notificationService.error('Please select size', 'Error');
        return;
      }
      if (!this.wishList.styleid) {
        this.notificationService.error('Please select color', 'Error');
        return;
      }
      if (this.wishList.designid == undefined) {
        this.wishList.designid = 0;
      }
      if (this.wishList.WarehouseProductId > 0) {
        this.wishList.customizedProductId = null;
      } else if (this.wishList.customizedProductId > 0) {
        this.wishList.customizedProductId = null;
      }
      this.loader.show();
      this.wishList.userid = this.userId;
      this.wishList.storeid = this.storeid;
      this.wishlistService.AddItemToWishList(this.wishList).subscribe((res: any) => {
        if (res.StatusCode === 200) {
          this.notificationService.success('Product added to wishlist', 'Success');
          this.loader.hide();
        } else {
          this.notificationService.error('An error occured', 'Error');
          this.loader.hide();
        }
      }, (err: any) => {
        this.loader.hide();
        this.errorhandlerService.handleError(err);
      });
    } else {
      this.notificationService.info('Please login before adding item to wishlist', 'WishList');
      this.popupService.openLogin(true);
      return false;
    }
  }

  /** function to load items in cart for specifc user of store */
  fn_GetCartItems() {
    this.loader.show();
    const userId = this.userId ? this.userId : this.getGuestId();
    this.cartService.GetCartItems(userId, this.storeid).subscribe((res: any) => {
      if (res.StatusCode === 200 && res.Data.ResponseData.length > 0) {
        const r = {
          cartItemCount: res.Data.ResponseData.length
        }; this.messageService.sendCartCount(r);
      }
    }, (error: any) => {
      this.errorhandlerService.handleError(error);
    });
  }

  /** Opens inksoft editor for customizing a product */
  fn_CustomizeProduct() {
    // var isLoggedIn = localStorage.getItem('token') ? true : false;
    this.userRole = localStorage.getItem('role');
    // this.storeUrl
    if (this.userRole === 'EndUser') {
      this.isLoggedIn = true;
      if (this.currentStyle !== null && this.currentStyle !== undefined) {
        this.router.navigate(['' + this.storeUrl + '/product/customize'],
          {
            queryParams: {
              'pid': this.productId, 'cid': this.selectedProduct.categoryId,
              'styleid': this.currentStyle, 'designId': this.designId
            }
          });
      } else {
        this.notificationService.error('Please select a color', 'Error');
      }
    }
    if (this.userRole === 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {
      this.isLoggedIn = true;
      if (this.currentStyle !== null && this.currentStyle !== undefined) {
        // *ngIf="this.currentStyle"
        this.router.navigate(['store/product/customize'], {
          queryParams: {
            'pid': this.productId, 'cid': this.selectedProduct.categoryId,
            'styleid': this.currentStyle
          }
        });
      } else {
        this.notificationService.error('Please select a color', 'Error');
      }
    }
    if (!this.isLoggedIn) {
      this.notificationService.info('Please login before Customize the product', 'Customize Product');
      this.popupService.openLogin(true);
      return false;
    }
  }

  /** Func to update design viewed count */
  fn_UpdateDesignViewedCount() {
    this.commonService.updateDesignViewedCount(this.storeid).subscribe((res: any) => { }, (err: any) => { });
  }

  editProduct() {
    this.loader.show();
    const storeId = this.storeid || localStorage.getItem('storeId') || '';
    const storeName = localStorage.getItem('storeName') || '';
    const imgBaseURL = environment.imgBaseURL;

    this.productService.getCustomizedProductDetailsWithStyle({
      productId: this.productId,
      designId: this.designId,
      storeId: Number(storeId) || 0
    }).subscribe((res: any) => {
      this.loader.hide();
      if (res.StatusCode === 200 && res.Data?.ResponseData) {
        const groupedData = res.Data.ResponseData;
        const productGrouped = Array.isArray(groupedData) ? groupedData[0] : groupedData;

        const allSavedStyles = (productGrouped.CustomizedProducts || []).reduce((acc: any[], cp: any) => {
          return acc.concat(cp.SavedStyles || []);
        }, []);

        const firstCP = productGrouped.CustomizedProducts?.[0] || {};
        const productDetails = {
          ...productGrouped,
          CustomizedProductId: firstCP.CustomizedProductId,
          StyleId: firstCP.StyleId || this.defaultStyleUniqueId,
          Name: firstCP.Name,
          PngRelativeUrlWithProduct: firstCP.PngRelativeUrlWithProduct,
          ThumbnailRelativeUrl: firstCP.ThumbnailRelativeUrl,
          PngRelativeUrl: firstCP.PngRelativeUrl,
          SvgRelativeUrl: firstCP.SvgRelativeUrl,
          PrintRegion: firstCP.PrintRegion,
          SideDisplayName: firstCP.SideDisplayName,
          SideName: firstCP.SideName,
          ProductMetadata: firstCP.ProductMetadata,
          Tags: firstCP.Tags,
          DesignHuddleProjectId: firstCP.DesignHuddleProjectId,
          DesignHuddleTemplateId: firstCP.DesignHuddleTemplateId,
          DesignHuddleJobId: firstCP.DesignHuddleJobId,
          AzureBlobThumbnailUrl: firstCP.AzureBlobThumbnailUrl,
          AzureBlobPrintFileUrl: firstCP.AzureBlobPrintFileUrl,
          Customizations: firstCP.Customizations,
          ElementPlacement: firstCP.ElementPlacement,
          ZonePlacement: firstCP.ZonePlacement,
          RetailPrice: firstCP.RetailPrice,
          PrintingCost: firstCP.PrintingCost,
          SavedStyles: allSavedStyles,
          Sizes: firstCP.Sizes,
          CustomizedProducts: productGrouped.CustomizedProducts
        };

        const editData = {
          ProductId: this.productId,
          DesignId: this.designId,
          StyleId: this.defaultStyleUniqueId,
          IsShopifyProduct: this.IsShopifyProduct,
          productDetails: productDetails,
          listItem: null,
          storeId: storeId,
          storeName: storeName
        };

        this.stateService.setEditMode(true, editData);

        // Extract logo URL from Customizations
        let designUrl = '';
        const firstCPCustomizations = firstCP.Customizations;
        if (firstCPCustomizations) {
          try {
            const parsed = typeof firstCPCustomizations === 'string'
              ? JSON.parse(firstCPCustomizations) : firstCPCustomizations;
            designUrl = parsed?.classes?.logo?.url || '';
          } catch (e) { }
        }
        if (!designUrl && firstCP.PngRelativeUrl) {
          designUrl = firstCP.PngRelativeUrl.startsWith('http')
            ? firstCP.PngRelativeUrl
            : imgBaseURL + firstCP.PngRelativeUrl;
        }
        const previewUrl = firstCP.PngRelativeUrlWithProduct
          ? (firstCP.PngRelativeUrlWithProduct.startsWith('http')
            ? firstCP.PngRelativeUrlWithProduct
            : imgBaseURL + firstCP.PngRelativeUrlWithProduct)
          : designUrl;

        this.stateService.setDesignData({
          type: 'uploaded',
          logoUrl: designUrl,
          previewUrl: previewUrl,
          designUrl: designUrl,
          fileName: '',
          file: null,
          isEdit: true,
          designId: this.designId
        });

        const prefix = getRoutePrefix(this.router.url);
        this.router.navigate([`${prefix}/edit-master-product`], {
          queryParams: { storeId: storeId, storeName: storeName }
        });
      } else {
        this.notificationService.error('Failed to load product details', 'Error');
      }
    }, (err: any) => {
      this.loader.hide();
      this.notificationService.error('Error loading product details', 'Error');
    });
  }

  showAddProductWindow() {
    this.router.navigate(['/store/addproduct']);
  }

  // ---- Decoration selector (WI-1378) ----------------------------------------

  /**
   * Load decorations for the product.  Called after the product/productAdditionalInfo loads.
   * @param masterProductId  Product.ProductId (EF PK) — the key the backend joins on.
   */
  private loadDecorations(masterProductId: number) {
    if (!masterProductId) { return; }
    this.masterProductId = masterProductId;
    const storeId = this.storeid ? Number(this.storeid) : undefined;
    this.decorationTypeService.getProductDecorations(masterProductId, storeId).subscribe(
      (decorations: ProductDecoration[]) => {
        this.decorations = decorations;
        if (decorations && decorations.length > 0) {
          const defaultDec = decorations.find(d => d.IsDefault) || decorations[0];
          this.selectedDecoration = defaultDec;
          this.defaultDecorationRate = defaultDec.Rate;
          // Propagate to cart payload
          this.cartProduct.DecorationTypeId = defaultDec.DecorationTypeId;
        }
      },
      () => {
        // Silently ignore — decoration selector simply stays hidden
        this.decorations = [];
      }
    );
  }

  /**
   * Called when the shopper picks a decoration from the selector.
   * Updates selectedDecoration, adjusts the displayed price by the delta in Rate,
   * and stores the chosen DecorationTypeId on cartProduct for the add-to-cart payload.
   */
  selectDecoration(decoration: ProductDecoration) {
    if (!decoration || this.selectedDecoration === decoration) { return; }

    const rateDelta = decoration.Rate - (this.selectedDecoration ? this.selectedDecoration.Rate : this.defaultDecorationRate);
    this.selectedDecoration = decoration;
    this.cartProduct.DecorationTypeId = decoration.DecorationTypeId;

    // Adjust the displayed final cost by the delta between the old and new decoration rates.
    // fn_getProductFinalCost uses this.EmbroideryCost (for embroidery) or selectedProduct.printingCost
    // (for non-embroidery) as the decoration/finishing cost component.  Rather than recompute the
    // full formula (which would require knowing which branch is active), we apply a non-destructive
    // delta to the already-computed productFinalCost.  This keeps the adjustment consistent across
    // all role/embroidery branches and avoids duplicating the formula logic here.
    this.selectedProduct.productFinalCost = this.selectedProduct.productFinalCost + rateDelta;
  }

  // ---- End decoration selector -----------------------------------------------

  checkDecorationTypeChanged() {
    // Check if decoration type exists and tags exist
    if (this.DecorationType && this.productTags && this.productTags.length > 0) {
      // Get the first tag (which should be decoration type if it exists)
      const firstTag = this.productTags[0]?.tagtext;
      // Check if first tag is different from current decoration type
      this.isDecorationTypeChanged = firstTag && firstTag !== this.DecorationType;
    } else {
      this.isDecorationTypeChanged = false;
    }
  }

  openEditTextWindow() {
    // Get the old decoration type tag (first tag if it exists)
    let oldDecorationTypeTag = null;
    if (this.productTags && this.productTags.length > 0 && this.productTags[0].tagtext) {
      oldDecorationTypeTag = this.productTags[0].tagtext;
    }

    const data: IProductDetailEditTextData = {
      title: this.selectedProduct.name,
      description: this.selectedProduct.rawDescription,
      labelData: this.selectedProduct.labelData,
      tagData: this.selectedProduct.tagData,
      isSuperAdmin: this.isSuperAdmin,
      decorationType: this.DecorationType,
      oldDecorationTypeTag: oldDecorationTypeTag
    };
    const dialogRef = this.dialog.open(ProductDetailEditTextComponent, {
      data: data,
      width: '850px',
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        var payload = {
          Title: result.data.title,
          ProductId: this.productId,
          Description: result.data.description,
          DesignId: this.designId,
          StyleId: Number(this.colorList.find(x => x.IsDefault).uniqueStyleId),
          ProductMetadata: result.labelData,
          Tags: result.tagData
        }
        this.productService.updateProductText(payload).subscribe((res: any) => {
          if (res.StatusCode === 200) {
            this.productService.getShopifyStoreKey({ designId: this.designId }).subscribe((res1: any) => {
              if (res1.StatusCode == 200)
                var metafield = {
                  productId: this.designId,
                  key: "product_label",
                  type: "json",
                  namespace: "custom",
                  value: JSON.parse(result.labelData || '[]'),
                  apiKey: res1.apikey
                }
              this.productService.UpdateMetafield(metafield).subscribe((res2: any) => {

              })

              var taglist = JSON.parse(result.tagData);
              let tagInfo = []

              if (taglist.length == 1 && !taglist[0].tagtext) {
                tagInfo.push({});
              } else {
                for (let i = 0; i < taglist.length; i++) {
                  if (taglist[i].tagtext) {
                    tagInfo.push(taglist[i].tagtext)
                  }
                }

              }
              var tags = {
                productId: this.designId,
                value: tagInfo.join(','),
                apiKey: res1.apikey
              };
              this.productService.UpdateTag(tags).subscribe((res2: any) => {

              })
            })
            this.notificationService.success('Product has Updated', 'Success');
            // Reload data from database to display saved values
            this.getProduct();
          }

        });

      }
    });
  }

  /** Opens publish to store popup */
  fn_OpenPublishModal(CustomizedProductId: number, ProductId: number, DesignId: number) {
    const dialogRef = this.dialog.open(PublishProductComponent, {
      // minWidth: '580px',
      width: '700px',
      data: { CustomizedProductId, DesignId, ProductId, WarehouseProductId: this.cartProduct.warehouseProductId, IsWareHouseProduct: this.selectedProduct.isWarehouseProduct }
    });
    dialogRef.afterClosed().subscribe(() => {
      // this.fn_getStoreList();
    });
  }

  // Open modal for upload images of product
  fn_OpenUploadImageModal() {
    let productId = this.productId;
    let designId = this.designId;
    let imageList = this.imageList;
    let styleId = this.currentStyleId;
    const dialogRef = this.dialog.open(UploadProductImageDialogComponent, {
      width: '700px',
      data: { productId, designId, imageList, styleId }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res == true) {
        this.getProduct();
      }
    });
  }

  fn_SetDefaultImage(img: CustomProductImageInterface) {
    var filename = '';
    let model: UpdateDefaultProductImageInterface = {
      ProductId: Number(this.productId),
      DesignId: Number(this.designId),
      ImageId: img.Id
    };
    this.loader.show();
    this.productService.updateDefaultProductImage(model).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.notificationService.success(res.Message, 'Default Image updated');
        this.imageList.map((x) => {
          x.IsDefault = false;
          return x;
        });
        let defaultImage = this.imageList.find(x => x.Id == img.Id);
        defaultImage.IsDefault = true;
      }
      this.loader.hide();
    }, (err: any) => {
      this.loader.hide();
      // this.notificationService.error('An error occured', 'Error');
      this.errorhandlerService.handleError(err);
    });
  }

  fn_replaceProduct() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: "To replace this product with another one, choose the target product on next screen.",
        title: "Replace product ?"
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // const replaceDialogRef = this.dialog.open(AddProductPopupComponent, {
        //   data: {
        //     ProductIdOld: this.productId,
        //     designId: this.designId,
        //     shopifyProduct: this.IsShopifyProduct,
        //     isProductReplaceCase: true
        //   }
        // });

        // replaceDialogRef.afterClosed().subscribe(res => {

        // });
        const data: AddProductPopupCompData = {
          designId: this.designId,
          ProductIdOld: this.productId,
          IsPublished: this.IsPublished,
          shopifyProduct: this.IsShopifyProduct,
          isEditCase: true,
          isProductReplaceCase: true,
          ProductAdditionalInfo: null,
          SizingLabelExist: false,
          Sizes: null
        };
        this.stateService.updateAddProductPopupdata(data);
        this.router.navigate(['/store/addproduct']);
      }
    });
  }
  fn_GetSizeQty(productId, styleId) {
    const cacheKey = `${productId}_${styleId}`;
    if (this.sizeQtyCache[cacheKey]) {
      this.applyQtyResult(this.sizeQtyCache[cacheKey]);
      this.loading = false;
      return;
    }
    this.loader.show();
    this.productService.getSizeQty(productId, styleId).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        var result = res.Data.ResponseData[0]
        this.sizeQtyCache[cacheKey] = result;
        this.applyQtyResult(result);
      }
      this.loading = false
      this.loader.hide();
    }, (err: any) => {
      this.loader.hide();
      this.loading = false
      this.errorhandlerService.handleError(err);
    });
  }

  private applyQtyResult(result: any) {
    if (result && result.Sizes.length > 0) {
      result.Sizes.forEach(element => {
        const size = this.currentSizeName.find(x => x.UniqueSizeId == element.UniqueSizeId || x.Name == element.Size);
        if (size) size.AvailableQty = element.InventoryCount;
      });
    }
  }
}
